import React from 'react';
import Postagem from './Postagem';
import { icon } from '../Icons'
import ValidaPostagens from './ValidaPostagens'

export default function Postagens(props) {

    const acrescentarLink = () => {
        const maisUmLink = { link:'', tipo:'' };
        const links = props.links.concat(maisUmLink);
        props.setLinks([]);
        props.setLinks(links);
    }

    const removerLink = index => {
        const links = [];
        for (let i=0; i<props.links.length; i++) {
            if (i !== index) {
                links.push(props.links[i]);
            }
        }
        props.setLinks([]);
        props.setLinks(links);
    }

    const atualizarLink = (rotulo,valor,index) => {
        const links = [].concat(props.links);
        links[index] = { ...links[index], [rotulo]:valor };
        props.setLinks([]);
        props.setLinks(links);
    }

    const renderLinks = () => {
        if (!props.links) {
            return null;
        }
        if ( props.links.length === 0) {
            return null;
        }

        const links = props.links;
        return links.map( (link, index) => {
            return (
                <Postagem 
                    key={"idFormDenunciaLinkVideo_" + index}
                    link={ link }
                    acrescentarLink={ acrescentarLink } 
                    removerLink={ removerLink } 
                    atualizarLink={ atualizarLink }
                    indice={ index } 
                />
            );
        });
    }
    const abreFormularioNarrativa = () => {
        props.atuLinhaDoTempo('narrativa')
    }

    const abreFormularioEnviarArquivos = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        ValidaPostagens.valida(props.links)
        .then( links => {
            props.setLinks(links)
            props.atuLinhaDoTempo('enviarArquivos')
        })
        .catch( msgErro => {
            props.setMensagem(msgErro)
        })
    }

    const secaoPostagens = () => {
        return (
            <>
                <fieldset className="border p-2">
                    <legend  className="w-auto">
                        <button className="btn btn-sm" onClick={ () => acrescentarLink() } type="button">
                            <h4>
                                <small>
                                    { "Nova: " }
                                    <icon.FaVideo className="text-success" aria-hidden="true" />
                                    <span className="text-success">+</span>   
                                </small>
                            </h4> 
                        </button>
                    </legend>
                    <div>
                        { renderLinks() }
                    </div>
                </fieldset>
                <div className="mt-4">
                    <div className="d-flex justify-content-between">
                        <button 
                            type="button" 
                            className="btn btn-outline-primary" 
                            onClick={ abreFormularioNarrativa }
                        >
                            Anterior
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-outline-primary " 
                            onClick={ abreFormularioEnviarArquivos }
                        >
                            Próximo
                        </button>
                    </div>
                </div>
            </>
        );
    }
    
    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "postagens") {
        return null;
    }

    return (
        <fieldset className="border p-4 mt-4">
            <legend className="row w-auto">
                <h4 className="ml-3"><small>Enviar postagens da internet:</small></h4> 
            </legend>
            <small className="form-text text-muted ml-3 mb-4 text-justify">
                <strong>. Aqui você pode colar links de postagens de documentos, vídeos, fotos, planilhas, textos e áudios da internet e redes sociais, os quais poderão ser utilizados como evidência da ocorrência relatada.</strong>
            </small>
            { secaoPostagens() }
        </fieldset>
    )
}